import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './style/index.css'//初始化样式

//引入Element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
